import { Injectable, Injector } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
    HttpResponse
} from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators'
import { BackgroundJobsService } from './services/background-jobs.service';
import { SharedDataService } from './services/shared-data.service';
@Injectable()
export class FS3Interceptor implements HttpInterceptor {

    private apiUrl = `/api/1.0/`;  // URL to web API
    private jobService;
    private sharedDataService;

    constructor(private injector: Injector ) {
        setTimeout(() => {
            this.jobService = this.injector.get(BackgroundJobsService);
        })
        this.sharedDataService = this.injector.get(SharedDataService);
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        req = req.clone({
            setHeaders: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-store'
            },
            url: this.apiUrl + req.url
        });

        return next.handle(req).pipe(
            tap(evt => {
                if (evt instanceof HttpResponse) {
                    if (evt.status === 202) {
                        this.jobService.addJob(evt.body.job_id)
                    }
                }
            }),
            catchError((error: HttpErrorResponse) => {
                if (!error.status) {
                    this.sharedDataService.pushNotification({
                        text:  'Sorry, Internet connection error occurred. Please check your Internet connection.',
                        type: 'error'
                    })
                    return throwError({
                        exception: error,
                    });
                }
                // Need to refactor to normal object instead of string
                let message = '';
                if (error && error.error && error.error.message) {
                  message = error.error.message
                } else if (error && error.statusText) {
                  message = error.statusText;
                }
                const errMsg = `${error.status} - ${message}`;
                return throwError({ exception: error, errMsg });
            })
        )
    }
}
